export const formStepperStyle = {
	wrapper: {
		maxWidth: '374px',
		width: '100%',
	},

	stepper: {
		width: '124px',
		position: 'absolute',
		bottom: 0,
		left: 'calc(50% - 62px)',

		'& .MuiStepConnector-root': {
			width: '24px',
		},

		'& .Mui-active': {
			width: '60px',
		},

		'& .Mui-completed .MuiStepConnector-line': {
			borderColor: 'var(--neutral-100) !important',
		},
	},

	email: {
		display: {
			xs: 'none',
			lg: 'block',
		},
		position: 'absolute',
		right: 0,
		color: 'var(--neutral-300)',
		fontWeight: 400,
		bottom: 0,
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 20px',
			width: '100%',

			'& > div': {
				maxWidth: '370px',
				margin: '0 auto',

				'&> div svg path': {
					fill: 'var(--success-500)',
				},
			},
		},

		'& .MuiDialogContentText-root': {
			marginBottom: '32px',
		},
	},
};
